<template>
  <div class="driver-container">
    <header class="relative">
      <img :src="$oss(16)" alt="" srcset="" />
      <div
        class="
          center
          width-full
          padding-lr-14
          flex
          justify-between
          align-center
        "
      >
        <div class="flex align-center">
          <img :src="info.headUrl" width="49px" alt="" srcset="" />
          <div class="padding-left-12">
            <div class="text-16 text-bold">{{ info.nickname }}</div>
            <div class="margin-top-4 text-12 text-grey">
              {{ info.mobile | hideMobile }}
            </div>
          </div>
        </div>
        <div class="flex align-center">
          <img :src="$oss(15)" width="32" alt="" srcset="" />
          <div class="padding-left-8">
            <div class="text-bold text-12" style="color: #9e4b00">
              信用分 {{ info.gradeCount }}
            </div>
            <div class="marign-top-4 text-10" style="color: #d27b39">
              当前状态{{ info.gradeStr }}
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="margin-lr-14">
      <div
        class="
          box-shadow
          cumulative
          flex
          justify-around
          align-center
          padding-lr-16 padding-tb-20
        "
      >
        <div class="flex flex-y align-center">
          <div class="text-12 text-grey">加入顺风车</div>
          <div class="margin-top-6">
            <span class="text-18 text-bold">{{ info.joinDay }}</span>
            <span class="text-12">天</span>
          </div>
        </div>
        <div class="flex flex-y align-center">
          <div class="text-12 text-grey">累积出行</div>
          <div class="margin-top-6">
            <span class="text-18 text-bold">{{ info.paOrders }}</span>
            <span class="text-12">次</span>
          </div>
        </div>
      </div>

      <div class="margin-top-14 box-shadow padding-14">
        <div class="flex justify-between align-center">
          <div class="flex align-center">
            <img :src="$oss(13)" width="28" alt="" srcset="" />
            <div class="text-bold margin-left-4">车主的评价</div>
          </div>
          <div class="text-grey text-12">
            评分<span class="text-primary">{{ info.commentScore }}</span
            >分
          </div>
        </div>
        <div v-if="info.tags.length" class="comment-container margin-top-14">
          <div
            v-for="item in info.tags"
            :key="item.tagId"
            class="
              text-center
              padding-tb-6
              radius
            "
            :class="[ item.tagType ==='差评' ? 'negative' : 'positively' ]"
          >
            {{ item.tagName }}&nbsp;{{ item.count }}
          </div>
        </div>

        <div v-else class="margin-tb-28 text-center text-grey text-12">暂无标签</div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchUserInfo } from 'api/user'
export default {
  data () {
    return {
      info: {
        tags: [],
        car: {}
      }
    }
  },
  created () {
    this.fetchUserInfo()
  },
  methods: {
    fetchUserInfo () {
      fetchUserInfo({
        userId: this.$route.params.id,
        userType: 1
      }).then((res) => {
        this.info = res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.driver-container {
  background-color: #fff;
  min-height: 100vh;
}

.cumulative {
  border-radius: 6px;
  position: relative;
  z-index: 1;
  margin-top: -12%;
  background: #fff;
}
.box-shadow {
  box-shadow: 0 0 12px 0 #eee;
}

.comment-container {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, 1fr);
}

.positively {
  color: $grey;
  border: 1px solid $grey;
}

.negative {
  color: $grey1;
  border: 1px solid $grey1;
}
</style>
